import { LDFlagSet } from 'launchdarkly-js-client-sdk';

import { RootState } from 'store/reducer';

export const selectFeatureFlags = (state: RootState): LDFlagSet => state.featureFlags;
